// extracted by mini-css-extract-plugin
export var box = "Item-module--box--bb212";
export var box_md = "Item-module--box_md--65464";
export var box_xmd = "Item-module--box_xmd--5bea8";
export var box_flex = "Item-module--box_flex--ab7c5";
export var box_lg = "Item-module--box_lg--81d04";
export var box_sm = "Item-module--box_sm--b5358";
export var box_outer = "Item-module--box_outer--441e5";
export var box_whiteBg = "Item-module--box_white-bg--b56a0";
export var box_noMarginBottom = "Item-module--box_no-margin-bottom--b56b8";
export var box_noPadding = "Item-module--box_no-padding--56262";
export var box_outerGray = "Item-module--box_outer-gray--3956e";
export var box_dark = "Item-module--box_dark--1a28f";
export var box_zIndex = "Item-module--box_z-index--08866";
export var box_zIndex6 = "Item-module--box_z-index-6--ca30d";
export var box_eventsWithLine = "Item-module--box_events-with-line--8fd64";
export var box_featuresAo = "Item-module--box_features-ao--e7a98";
export var box_verticalPaddings = "Item-module--box_vertical-paddings--e1e56";
export var clearP = "Item-module--clearP--35401";
export var clearP_vc = "Item-module--clearP_vc--529c6";
export var article = "Item-module--article--4bc64";
export var author = "Item-module--author--60df0";
export var authorName = "Item-module--authorName--2f248";
export var authorImg = "Item-module--authorImg--c3e16";
export var authorInfo = "Item-module--authorInfo--78555";
export var authorNameWrapper = "Item-module--authorNameWrapper--2f13d";
export var linkedinIcon = "Item-module--linkedinIcon--5d897";
export var message = "Item-module--message--9ac6a";
export var authorPosition = "Item-module--authorPosition--0abad";
export var fadeInAnimation = "Item-module--fadeInAnimation--b9baf";
export var placeHolderShimmer = "Item-module--placeHolderShimmer--c1d35";